// Mock data for ICT TechSolutions website

export const services = [
  {
    id: 1,
    title: "Microsoft 365 Solutions",
    icon: "cloud",
    description: "Complete O365 setup, migration, and management for seamless productivity.",
    features: [
      "Email migration and setup",
      "SharePoint configuration",
      "Teams deployment and training",
      "Security and compliance setup",
      "Ongoing support and maintenance"
    ]
  },
  {
    id: 2,
    title: "Azure Cloud Services",
    icon: "server",
    description: "Scalable cloud infrastructure with Azure for your business growth.",
    features: [
      "Cloud infrastructure design",
      "Virtual machine deployment",
      "Database management",
      "Security and backup solutions",
      "Cost optimization"
    ]
  },
  {
    id: 3,
    title: "Google Workspace",
    icon: "mail",
    description: "Google Workspace implementation and management for modern collaboration.",
    features: [
      "Gmail and Drive setup",
      "Google Meet configuration",
      "Admin console management",
      "Data migration services",
      "User training and support"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Keith B",
    company: "Williamstown, VIC",
    role: "Customer",
    content: "A very professional service. Work carried out promptly to exacting standards. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Deborah G",
    company: "Melbourne, VIC",
    role: "Customer",
    content: "We hired Ani to fix our computer issues today, he was quick to respond with a quote and got the issues sorted today. Very happy with his service and courteous demeanor. He is very knowledgeable and reasonably priced. Would definitely hire him again.",
    rating: 5
  },
  {
    id: 3,
    name: "Patricia M",
    company: "Melbourne, VIC",
    role: "Customer",
    content: "Ani completed works required on my PC and laptop. Great communication, honest and reliable. It was great that he picked up and returned the computers to/from your home. Would recommend him for your IT needs.",
    rating: 5
  },
  {
    id: 4,
    name: "Blaize K",
    company: "Werribee, VIC",
    role: "Customer",
    content: "My experience with ICT tech solutions is exceptional. They went out of their way to aid, assist and repair my laptop. I tried 2 local businesses that could not assist, and when I came across ICT tech solutions they have repaired my laptop where others said they could not. Thank you ICT tech solutions.",
    rating: 5
  },
  {
    id: 5,
    name: "Chris W",
    company: "Hughesdale, VIC",
    role: "Customer",
    content: "Highly recommended. Ani followed up on his initial quote with a phone call to answer any questions I had, and was both patient and polite. He arrived at my house on the day and time of my choosing and stayed a bit longer than estimated to fix everything (which he didn't charge me for). We had a new drive and a working Windows OS, and all for less than the bigger chains' call-out fee. Problem solved, great value.",
    rating: 5
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Retail Business O365 Migration",
    client: "Melbourne Retail Co.",
    industry: "Retail",
    challenge: "Outdated email system causing productivity issues and security concerns.",
    solution: "Complete migration to Microsoft 365 with advanced security features and Teams deployment.",
    results: [
      "50% increase in team collaboration",
      "Zero security incidents in 12 months",
      "30% reduction in IT support tickets"
    ]
  },
  {
    id: 2,
    title: "Cloud Infrastructure for Growing Startup",
    client: "Tech Startup Hub",
    industry: "Technology",
    challenge: "Rapidly growing business needed scalable infrastructure without high upfront costs.",
    solution: "Azure cloud infrastructure with auto-scaling and optimized resource allocation.",
    results: [
      "60% reduction in infrastructure costs",
      "99.9% uptime achieved",
      "Seamless scaling during peak periods"
    ]
  },
  {
    id: 3,
    title: "Google Workspace for Professional Services",
    client: "Local Accounting Firm",
    industry: "Professional Services",
    challenge: "Need for better collaboration tools and secure document sharing with clients.",
    solution: "Google Workspace implementation with custom security policies and client portals.",
    results: [
      "40% faster document collaboration",
      "Enhanced client satisfaction scores",
      "Improved remote work capabilities"
    ]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$349",
    period: "one-time setup",
    description: "Perfect for individuals and very small businesses",
    features: [
      "Up to 5 user accounts",
      "Basic email setup",
      "1 hour training session",
      "30 days email support",
      "Documentation provided"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Business",
    price: "$949",
    period: "one-time setup + $199/month support",
    description: "Ideal for small to medium businesses",
    features: [
      "Up to 25 user accounts",
      "Complete platform migration",
      "Custom configuration",
      "4 hours training sessions",
      "Priority support",
      "Monthly health checks"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "tailored to your needs",
    description: "For large organizations with complex requirements",
    features: [
      "Unlimited users",
      "Advanced security setup",
      "Dedicated account manager",
      "Comprehensive training program",
      "24/7 priority support",
      "Custom integrations",
      "Quarterly strategy reviews"
    ],
    popular: false
  }
];

export const stats = [
  {
    id: 1,
    value: "150+",
    label: "Happy Clients"
  },
  {
    id: 2,
    value: "99.9%",
    label: "Uptime Guarantee"
  },
  {
    id: 3,
    value: "15+",
    label: "Years Experience"
  },
  {
    id: 4,
    value: "24/7",
    label: "Support Available"
  }
];

export const team = [
  {
    id: 1,
    name: "John Anderson",
    role: "Founder & Lead Consultant",
    bio: "15+ years in IT consulting with expertise in cloud solutions and digital transformation.",
    certifications: ["Microsoft Certified", "Azure Solutions Architect", "Google Cloud Professional"]
  },
  {
    id: 2,
    name: "Lisa Martinez",
    role: "Senior Cloud Engineer",
    bio: "Specializes in Azure infrastructure and migration strategies for businesses of all sizes.",
    certifications: ["Azure Administrator", "Azure Security Engineer"]
  },
  {
    id: 3,
    name: "David Kim",
    role: "O365 Specialist",
    bio: "Expert in Microsoft 365 implementations with focus on security and compliance.",
    certifications: ["Microsoft 365 Certified", "Security & Compliance"]
  }
];
